import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
import SelectedFilters from "./SelectedFilters"
import Loader from "./elements/Loader"

export default function Category() {
    const {
        response: { products },
        loading
    } = useAppState()
    const foundProducts = products && products.total > 0

    console.log('foundProducts:', products)

    return (
        <div class="facets-vertical">
            {foundProducts && (
                <>
                    <Sidebar />
                    {/* <Toolbar mobile /> */}
                </>
            )}
            <div class="product-grid-container scroll-trigger animate--slide-in">
                {foundProducts ? (
                    <div class='collection'>
                        {/* <SelectedFilters /> */}
                        <Toolbar />
                        <ul class="plp-grid-new">
                            <Products />
                        </ul>
                        <BottomToolbar />
                    </div>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )}

                {/* To enable InfiniteScroll - comment above block and uncomment below.
                    Don't forget to import InfiniteScroll component. */}
                {/* {foundProducts ? (
                    <>
                        <SelectedFilters />
                        <Toolbar />
                        <InfiniteScroll>
                            <Products />
                        </InfiniteScroll>
                    </>
                ) : loading ? (
                    <Loader />
                ) : (
                    <NoResults />
                )} */}
            </div>
        </div>
    )
}
